import React from 'react';
export default class ErrorHandler extends React.Component {
    constructor({ component }) {
        super();
        this.state = {
            hasError: false,
        };
        this.errorComponent = component;
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
        };
    }

    componentDidCatch(error, errorInfo) {
        console.log(typeof error.stack, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.errorComponent || null;
        }

        return <React.Fragment>{this.props.children}</React.Fragment>;
    }
}
